import { useState } from 'react';
import { GroupProps, GroupState } from './groupTypes';

export function useGroupState<T>({
  defaultValue,
  value,
  onValueChange,
  onChange,
  ...rest
}: Omit<GroupProps<T>, 'children'>): GroupState<T> {
  const [isInputControlled] = useState(value !== undefined);
  const changeCallback = (newValue: T) => {
    onValueChange?.(newValue);
    onChange?.(newValue);
  };
  const [currentValueFromHook, setCurrentValueFromHook] = useState<null | T>(
    defaultValue || null
  );
  const hasError = rest.hasError || Boolean(rest.errorMessage);
  const hasWarning = rest.hasWarning || Boolean(rest.warningMessage);
  const { currentValue, setCurrentValue } = isInputControlled
    ? { currentValue: value, setCurrentValue: changeCallback }
    : {
        currentValue: currentValueFromHook,
        setCurrentValue: (newValue: T) => {
          setCurrentValueFromHook(newValue);
          changeCallback(newValue);
        },
      };

  return {
    currentValue,
    setCurrentValue,
    ...rest,
    hasError,
    hasWarning,
  };
}
